module.exports = __webpack_public_path__ + "media/images/landing/apple_store-e86adaa3665670d2d0fcfec629bde6e6.png";